import keymirror from 'keymirror'

export const DEVICE_DETAILS = 'invest.incomebazaar.com'
export const ICICI_BACKEND_API_URL = 'https://api.tradecred.com'
export const IDFC_BACKEND_API_URL = 'https://idfcapi.tradecred.com'
export const DBS_BACKEND_API_URL = 'https://dbsapi.tradecred.com'
export const IC_BAKCEND_API_URL = 'https://api.incomebazaar.com'
export const STAGING_BACKEND_API_URL = 'https://staging-backend.tradecred.com/'
const DEV_BACKEND_API_URL = 'http://0.0.0.0:3300'

export const isPROD = process.env.REACT_APP_PRODUCTION
export const isStaging = process.env.REACT_APP_STAGING

export const BASE_URLS = isPROD ? [IC_BAKCEND_API_URL] : isStaging ? [STAGING_BACKEND_API_URL] : [DEV_BACKEND_API_URL]

export const REGISTER_BACKEND_URL = isPROD
  ? IC_BAKCEND_API_URL
  : isStaging
  ? STAGING_BACKEND_API_URL
  : DEV_BACKEND_API_URL

export const BASE_URL_KEY = '@baseUrl'
export const ACCESS_TOKEN_KEY = '@accessToken'
export const REFRESH_TOKEN_KEY = '@refreshToken'
export const WITHDRAWAL_REASONS_KEY = '@withdrawalReasons'
export const WITHDRAWAL_REASON_DAY_KEY = '@withdrawalReasonDay'

export const INR = '₹'

export const DEAL = keymirror({
  STANDARD: null,
  DEBT: null,
  LEASE: null,
  STANDARD_SECONDARY: null,
  DEBT_SECONDARY: null,
  LEASE_SECONDARY: null,
})

export const PORTFOLIO = keymirror({
  STANDARD: null,
  DEBT: null,
  LEASE: null,
  STANDARD_SECONDARY: null,
  DEBT_SECONDARY: null,
  LEASE_SECONDARY: null,
})

export const PORTFOLIO_FILTERS = [
  { title: 'Ongoing deal', state: 'completed' },
  { title: 'Pending for approval', state: 'subscriber_sign_requested' },
  { title: 'Completed deal', state: 'settled' },
]

export const TRADECRED_ASSET_LOGO = '/assets/images/IncomeBazaarLogo.png'
export const TRADECRED_SUPPORT_EMAIL = 'help@incomebazaar.com'
export const TRADECRED_SUPPORT_PHONE = ['+91 90229 36378', '+91 85917 44436', '+91 85910 77156']
export const BUYER_LINK = 'invest.incomebazaar.com'
export const isTradecred = false
export const COMPANY_LEGAL_NAME = isTradecred
  ? 'Ikshavaku Software Ventures India Private Limited'
  : 'Shimshon Advisory Private Limited'
export const COMPANY_LEGAL_INITIALS = isTradecred ? 'ISVIPL' : 'SAPL'
export const COMPANY_NAME = isTradecred ? 'TradeCred' : 'Income Bazaar'
export const COMPANY_PAN = isTradecred ? 'AAECI8853N' : 'AARFJ8322K'
export const TNC_BANK_DETAILS = isTradecred
  ? [
      ['Bank 1', 'ICICI Bank Limited'],
      ['Bank 2', 'IDFC First Bank Limited'],
      ['Bank 3', 'Kotak Mahindra Bank Limited'],
      ['Bank 4', 'HDFC Bank Limited'],
      ['Bank 5', 'DBS Bank Limited'],
      ['Bank 6', 'Yes Bank Limited'],
    ]
  : [
      ['Bank 1', 'IDFC First Bank Limited'],
      ['Bank 2', 'Kotak Mahindra Bank Limited'],
      ['Bank 3', 'HDFC Bank Limited'],
      ['Bank 4', 'ICICI Bank Limited'],
      ['Bank 5', 'Yes Bank Limited'],
    ]

export const IFSC_FORMAT = /^[A-Za-z]{4}[0][A-Za-z0-9]{6}$/
